import React, { useState } from "react";
import { Drawer, List, Collapse } from "@material-ui/core";
import clsx from "clsx";
import { useMenuStyles } from "./DrawerMenuStyles";
import MenuItem from "./DrawerMenuItem";
import consts, { leftNavMenuItem, leftNavSubMenuItem } from "../../utils/consts";
import useNavIndexFromLocation from "../../utils/navIndexUtil";
import { history } from "../../services/historyService";

const DrawerMenu: React.FC = () => {
	const classes = useMenuStyles();
	const navMenu = consts.leftNav;
    const defaultNavIndex = useNavIndexFromLocation();
	const [selectedMenuItem, setSelectedMenuItem] = useState(defaultNavIndex?.index);
	const [expandedSubMenuNames, setExpandedSubMenuNames] = useState(defaultNavIndex?.subMenuName ? [defaultNavIndex.subMenuName] : []);

	const handleTopLevelMenuItemSelected = (item: leftNavMenuItem, hasSubMenu: boolean) => {
		if (!hasSubMenu) {
			// This is a top-level menu item, change the page
			setSelectedMenuItem(item.index);
			if (item.path) history.push(item.path);
			return;
		}

		const subMenuName = item.name;
		const isCurrentlyExpanded = expandedSubMenuNames.includes(subMenuName);
		if (!isCurrentlyExpanded) {
			setExpandedSubMenuNames(prev => [...prev, subMenuName]);
			return;
		}

		// Don't allow the sub-menu to be collapsed if it contains the current page
		if (subMenuName !== defaultNavIndex?.subMenuName) {
			setExpandedSubMenuNames(prev => prev.filter((name) => name !== subMenuName));
		}
	};

	const handleSubMenuItemSelected = (item: leftNavSubMenuItem, subMenuName: string) => {
		setSelectedMenuItem(item.index);
		history.push(item.path);
	}

	return (
		<Drawer
			variant="permanent"
			className={clsx(classes.drawer, classes.drawerOpen)}
			classes={{
				paper: clsx(classes.drawer, classes.drawerOpen),
			}}
			anchor="left"
		>
			<div className={classes.drawerContainer}>
				<List component="nav" className={classes.list}>
					{navMenu.map((item) => {						
						const hasSubMenu = item.subMenuItems != null && item.subMenuItems.length > 0;
						const subMenuExpanded = expandedSubMenuNames.includes(item.name);
						return (
							<div key={item.name}>
								<MenuItem
									{...item}
									selected={item.index != null && selectedMenuItem === item.index}
									onClick={() => handleTopLevelMenuItemSelected(item, hasSubMenu)}
									hasSubMenu={hasSubMenu}
									subMenuExpanded={subMenuExpanded}
								/>
								{hasSubMenu && (
									<Collapse in={subMenuExpanded} timeout="auto" unmountOnExit>
										{item.subMenuItems?.map((subMenuItem) => (
											<MenuItem
												key={subMenuItem.name}
												{...subMenuItem}
												selected={selectedMenuItem === subMenuItem.index}
												onClick={() => handleSubMenuItemSelected(subMenuItem, item.name)}
												isSubMenuItem
											/>
										))}
									</Collapse>
								)}
							</div>
						);
					})}
				</List>
			</div>
		</Drawer>
	);
};

export default DrawerMenu;
